export default {
      id: "search-loupe-usage",
      viewBox: "0 0 24.846 24.846",
      url: __webpack_public_path__ + "img/icons.8ad0c046.svg#search-loupe",
      toString: function () {
        return this.url;
      }
    }